import { useEffect, useState } from "react";
import axios from "axios";

const useClinicOptions = (activeOnly = true) => {
  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClinics = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("user_id");
        const params = new URLSearchParams({ simple: "true" });
        if (activeOnly) params.append("status", "Active");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/users/get-clinics?${params.toString()}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (response.data?.success) {
          setClinics(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching clinic options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClinics();
  }, [activeOnly]);

  return { clinics, loading };
};

export default useClinicOptions;
